import { ElementRef, Injectable, inject } from '@angular/core';
import { ReplaySubject, fromEvent } from 'rxjs';
import { WindowService } from './window.service';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  public scrolled = new ReplaySubject<Event>(1);

  readonly #windowService = inject(WindowService);

  constructor() {
    if (this.#windowService.getWindow().addEventListener) {
      fromEvent(this.#windowService.getWindow(), 'scroll').subscribe((event: Event) => {
        this.scrolled.next(event);
      });
      this.scrolled.next({} as any);
    } else {
      // this is only for making tests run
      this.scrolled.next(null);
    }
  }

  public isElementInView(elem: ElementRef, options?: { thresholdPct?: number; offsetTop?: number }): boolean {
    try {
      if (typeof elem.nativeElement.getBoundingClientRect !== 'function') {
        // this is for server side rendering
        return false;
      }
      const opts = options || {};
      const offsTop = opts.offsetTop || 0;
      const thresPct = opts.thresholdPct || 10;
      const thresholdFacotr = 1 - thresPct / 100;

      const elRect = elem.nativeElement.getBoundingClientRect();
      const elTop = elRect.top - offsTop;
      const elBottom = elRect.bottom;
      const elHeight = elBottom - elTop;
      const threshold = elHeight * thresholdFacotr;
      const isVisible = elTop + threshold >= 0 && elBottom - threshold <= this.#windowService.getWindow().innerHeight;
      return isVisible;
    } catch (e) {
      return true;
    }
  }

  public scrollElementIntoView(elem: ElementRef, top: boolean) {
    try {
      elem.nativeElement.scrollIntoView({
        block: top ? 'start' : 'end',
        behavior: 'smooth',
      });
    } catch (e) {
      // TODO: error handling
    }
  }

  public scrollToElementById(id: string, position: ScrollLogicalPosition = 'center') {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth', block: position });
  }
}
